<template>
    <div v-editable="blok" class="explainer" data-test="NewL4Explainer">
        <div class="explainer__container md:container">
            <!-- Begin: Explainer - Content -->

            <div v-if="blok?.content" class="explainer__content">
                <RichText :richtext="blok?.content" />
            </div>

            <!-- End: Explainer - Content -->
            <!-- Begin: Explainer - Image -->

            <div class="explainer__image">
                <NuxtImg
                    v-if="blok.image?.filename"
                    :src="blok.image?.filename"
                    :title="blok?.image.title"
                    :alt="blok?.image.alt"
                    width="525"
                    height="225"
                    provider="storyblok"
                    format="webp"
                    loading="lazy"
                    densities="x1"
                />
            </div>

            <!-- End: Explainer - Image -->
        </div>
    </div>
</template>

<script setup lang="ts">
import type { IL4ExplainerConfig } from '~/types/components/L4Explainer';

defineProps<{ blok: IL4ExplainerConfig }>();
</script>

<style lang="postcss" scoped>
.explainer {
    @apply bg-white;
}
.explainer__container {
    @apply flex items-end pt-16 pb-8 px-4 md:px-0 flex-col sm:flex-row;
}

/* Begin: Explainer - Content */
.explainer__content {
    @apply w-full text-primary;
}

.explainer__content :deep(h2) {
    @apply font-semibold text-xl my-4;
}

.explainer__content :deep(h2 b) {
    @apply font-bold;
}

.explainer__content :deep(p) {
    @apply text-base mb-4;
}
/* End: Explainer - Content */

/* Begin: Explainer - Image */
.explainer__image {
    @apply mb-8 w-full;
}
/* End: Explainer - Image */
</style>
